<template>
  <footer class="app-footer">
    <!-- <span>
      <a href="http://www.bladmjudcial.com.br">
        &copy; BL Adm Judicial
      </a>.
    </span> -->
    <span class="ml-auto">
      <a href="http://www.owinteractive.com">
        <img src="../../../static/img/ow.png" alt="">
      </a>
    </span>
  </footer>
</template>
<script>
export default {
  name: 'core-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/core/Footer.vue